import React, { useMemo, useCallback } from 'react';
import keys from 'lodash/keys';
import map from 'lodash/map';

import find from 'lodash/find';
import isArray from 'lodash/isArray';

import { ID } from '../../../../types';

import {
  MultiSelectExtendedDataType,
  MultiSelectChangeCallbackType
} from '../../../../helpers/MultiSelect/types';

import { useTranslate } from '../../../../common/hooks/useTranslate';

import { MultiSelect } from '../../../../helpers/MultiSelect';

import { teamNewFinI18nTextStatuses } from '../../teamsConstants';

interface TeamNewFinStatusesMultiSelectProps {
  value: ID[];
  autoFocus?: boolean;
  onChange: (value: ID[]) => void;
  name?: string;
  menuPosition?: 'absolute' | 'fixed';
}

function TeamNewFinStatusesMultiSelect({
  value,
  autoFocus,
  onChange,
  name,
  menuPosition
}: TeamNewFinStatusesMultiSelectProps) {
  const { t } = useTranslate();
  const data = useMemo<MultiSelectExtendedDataType[]>(() => {
    const statuses = keys(teamNewFinI18nTextStatuses);

    return map(statuses, (status) => ({
      value: status,
      label: t(teamNewFinI18nTextStatuses[status])
    }));
  }, [t]);

  const multiSelectValue = useMemo<MultiSelectExtendedDataType[]>(() => {
    return isArray(value)
      ? value.map((item) => find(data, ['value', item]))
      : [];
  }, [value, data]);

  const handleChange = useCallback<MultiSelectChangeCallbackType>(
    (value: MultiSelectExtendedDataType) => {
      onChange(isArray(value) ? value.map((item) => item.value) : []);
    },
    [onChange]
  );

  return (
    <MultiSelect
      inputWrapperClassName="block"
      onChange={handleChange}
      value={multiSelectValue}
      multi={true}
      isSearchable={true}
      data={data}
      classNamePrefix="av_multi_select"
      autoFocus={autoFocus}
      name={name}
      menuPosition={menuPosition}
    />
  );
}

export default TeamNewFinStatusesMultiSelect;
